import { render, staticRenderFns } from "./MobilidadeMetodoAssociacaoPage.vue?vue&type=template&id=7fac65cb"
import script from "./MobilidadeMetodoAssociacaoPage.vue?vue&type=script&lang=js"
export * from "./MobilidadeMetodoAssociacaoPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports